import { useCallback } from "react";
import { canonicalStateEmitter } from "@/services/useCanonicalState";
import { useCreateUrl } from "@/services/useCreateUrl";
import type { HybridNavigateOptions } from "@/types/HybridNavigateOptions";
// import { HybridNavigateOptions, useHybridRouter } from "@/services/useHybridRouter";
import { useHybridRouter } from "./router/useHybridRouter";

export type CommitTransformerFunction = (values: Record<string, string | undefined>) => Record<string, string | undefined>;

export function useCanonicalCommit(
	commitParamNames: string[],
	options: HybridNavigateOptions = {},
	transformer?: CommitTransformerFunction
) {
	const { push } = useHybridRouter();
	const createUrl = useCreateUrl();

	return useCallback(async () => {
		// Ask the relevant states for their current values
		let commitValues = commitParamNames.reduce((tmpObj: Record<string, string | undefined>, paramName) => {
			// Even though we receive an array, we only care about the first value in that array
			tmpObj[paramName] = canonicalStateEmitter.emitId("GetStateValue", paramName)[0];

			return tmpObj;
		}, {});

		if (transformer) {
			commitValues = transformer(commitValues);
		}

		const url = createUrl("", commitValues);
		console.info("Canonical commit url is", url);
		push(url, options);
	}, [commitParamNames, transformer, createUrl, push, options]);
}
